// User display title helpers (v5.4 Correction 2, updated per v5.6 Addition 4)
// Shows job_title (Title) if set; otherwise returns blank.
// Role is NEVER shown as a sub-label anywhere outside User Management edit form.

const ROLE_DEFAULT_TITLE = {
  superadmin: "Superadmin",
  vc_admin: "VC Admin",
  it_admin: "IT Admin",
  senior_vc: "Partner",
  junior_vc: "Analyst",
};

export function userTitle(user) {
  if (!user) return "";
  const jt = (user.job_title || "").trim();
  // v5.6 Addition 4: no role fallback outside User Management form
  return jt;
}

// Same signature but takes {role, job_title} shape or an enum string.
// Used as a suggested default/placeholder in User Management ONLY.
export function roleDefaultTitle(role) {
  return ROLE_DEFAULT_TITLE[role] || role || "";
}
